import { render, staticRenderFns } from "./CallIndex.vue?vue&type=template&id=334052a6"
import script from "./CallIndex.vue?vue&type=script&lang=js"
export * from "./CallIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports